import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService, UserService } from '@beecore/auth';
import { AuthError, BusinessError, IAbpApiResponse, IAbpApiTransportError, NotFoundError, UnauthorizedError } from '@beecore/core';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SfeAuthErrorHandlerService {

  /** @ignore */
  constructor(
    private readonly $auth: AuthService,
    private readonly $user: UserService
  ) { }

  /**
   * Trata objetos de erro do ABP e converte em instância de erro manipuláveis.
   *
   * {@link @angular/common/http#HttpErrorResonse}
   */
  handleErrors(error: HttpErrorResponse): Observable<never> {
    const response = error.error as IAbpApiResponse<IAbpApiTransportError>;

    switch (error.status) {
      case 404:
        return throwError(new NotFoundError(undefined, error.url));
      case 401:
        this.$auth.logout();
        return throwError(new AuthError(
          (response.error)
            ? response.error.message
            : error.message,
          401,
          response.error,
          true
        ));
      case 403:
        return throwError(new UnauthorizedError(
          (response.error)
            ? response.error.message
            : error.message,
          403,
          response.error,
          this.$user?.currentUser?.fullName,
          true
        ));
      default:
        this.$auth.logout();
        return throwError(new BusinessError(
          (response.error)
            ? response.error.message
            : error.message,
          error.status,
          response.error,
          true
        ));
    }
  }
}
